/* HALT commerce enhancements. Progressive: everything works without this file.
   - Product gallery: keeps the visible "1 / 7" image count in sync with Dawn's
     thumbnail state (aria-current) and enables the short image swap fade only
     after the shopper interacts, so the first image never animates in. */
(() => {
  const initGallery = (gallery) => {
    if (gallery.dataset.haltReady) return;
    gallery.dataset.haltReady = 'true';

    const current = gallery.querySelector('[data-halt-gallery-current]');
    const thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!current || !thumbs) return;

    // Ordinal by original DOM order (Dawn may prepend items on variant change).
    const order = new Map();
    thumbs.querySelectorAll('[data-target]').forEach((item, index) => order.set(item.dataset.target, index + 1));

    const sync = () => {
      const active = thumbs.querySelector('button[aria-current="true"]');
      const item = active && active.closest('[data-target]');
      if (item && order.has(item.dataset.target)) current.textContent = order.get(item.dataset.target);
    };

    thumbs.addEventListener('click', (event) => {
      if (event.target.closest('.thumbnail')) gallery.classList.add('halt-gallery--interacted');
    });

    new MutationObserver(sync).observe(thumbs, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-current'],
    });
    sync();
  };

  const run = () => document.querySelectorAll('[data-halt-gallery]').forEach(initGallery);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  // Dawn re-renders the product section on variant change.
  document.addEventListener('shopify:section:load', run);
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.variantChange, () => window.requestAnimationFrame(run));
  }
})();
